import { featureItems } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="mx-auto max-w-[1280px]">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
              为什么选择我们
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto">
              三大核心优势，打造极致的韩国漫画在线阅读体验
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
            {featureItems.map((item, i) => (
              <div
                key={i}
                className="relative bg-background-50 rounded-xl border border-background-200/60 p-6 md:p-8 text-center group hover:border-primary-200 transition-all duration-300"
              >
                <div className={`w-14 h-14 md:w-16 md:h-16 rounded-2xl flex items-center justify-center mx-auto mb-5 ${
                  i === 0
                    ? 'bg-primary-100'
                    : i === 1
                    ? 'bg-accent-100'
                    : 'bg-secondary-100'
                }`}>
                  <i className={`${item.icon} text-2xl md:text-3xl ${
                    i === 0
                      ? 'text-primary-500'
                      : i === 1
                      ? 'text-accent-500'
                      : 'text-secondary-500'
                  }`}></i>
                </div>
                <h3 className="text-lg font-heading font-bold text-foreground-900 mb-3">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}